import styled, { css } from 'styled-components'
import { shimmerAnim } from '../../utils'

type StyledProps = {
  $loading?: boolean
  $noVid?: boolean
  $error?: boolean
}

const StyledPlayer = styled.div<StyledProps>`
  position: relative;

  .fake-splash {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      border-radius: 50%;
      background-color: rgb(0, 0, 0, 0.6);
      transition: 0.2s ease-in-out;

      svg {
        flex-shrink: 0;
        position: relative;
        left: 2px;
        height: 40%;
        width: unset;
        min-height: 50px;
        color: ${({ theme }) => theme.color.background};
        fill: ${({ theme }) => theme.color.background};
      }
    }

    &:hover {
      .icon {
        transform: scale(1.05);
      }
    }
  }

  iframe,
  .player {
    width: 100%;
    position: ${({ $loading }) => ($loading ? 'absolute' : 'relative')};
    pointer-events: ${({ $loading }) => ($loading ? 'none' : 'unset')};
    opacity: ${({ $loading }) => ($loading ? '0' : '1')};
    visibility: ${({ $loading }) => ($loading ? 'hidden' : 'visible')};
  }

  ${({ $loading }) =>
    $loading &&
    css`
      padding-top: 56.25%;
      pointer-events: none;
      animation: ${shimmerAnim} 1.4s ease-in-out infinite;

      .fake-splash {
        display: none;
      }
    `}

  ${({ $error }) =>
    $error &&
    `
      padding-top: 56.25%;

      .player-error {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .message {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
          background-color: rgb(0, 0, 0, 0.6);
          color: #fff;

          svg {
            height: 40px;
            width: 40px;
          }
        }
      }
    `}

  ${({ $noVid }) =>
    $noVid &&
    `
      padding-top: 56.25%;
      pointer-events: none;
      
      .player {
        height: 0;
        width: 0;
        position: absolute;
        opacity: 0;
        pointer-events: none;
      }

      img {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    `}
`

export default StyledPlayer
